import React from 'react';
import '../css/site.css';
import '../css/w3.css'; 
import TopMenu from '../Components/TopMenu';
import { useNavigate } from 'react-router-dom';
import logo from '../img/logo.png';

const Header = () => {

  const navigate = useNavigate();
  const handleHomeClick = () => navigate('/');

  return (
    <>
    {/* Start Header Area */}  
        <header className="header main-header">
            <div id="main-sticky-placeholder"></div>
            <div className="main-mainmenu">
                <div className="container-fluid">
                    <div className="header-navbar">
                        <div className="header-logo">
                            <a onClick={handleHomeClick}><img src={logo} alt="logo" style={{cursor:"pointer"}}/></a>
                        </div>
                        <div className="header-main-nav">
                            {/* Start Mainmanu Nav */}
                            <TopMenu />
                            {/* End Mainmanu Nav */}
                        </div>
                    </div>
                </div>
            </div>
        </header>
        {/* End Header Area */}
    </>
  );
};

export default Header;